import {
    Bitmap,
    ButtonBase,
    Container,
    dispatcher,
    ingenuity,
    ITween,
    Label,
    Linear,
} from "@quest/base-core";
import { SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther";
import { SlotEventConstants } from "@quest/slot-core";

import { BannerScreenView } from "./BannerScreenView";
import { GameParserModel } from "../Platform/GameParserModel";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SoundConstantGame } from "../Constants/SoundConstantGame";

export class ClueRevealBannerController {
    private view: BannerScreenView;
    private msgCounter: number = 1;
    private totalMsgOnEachCount: number[] = [0, 3, 2, 3, 2, 3, 4, 4, 3, 2, 2, 3, 2, 3, 3, 2]


    private bannerBottomContainer: Container;
    private bannerMainContainer: Container;
    private bannerDetectiveContainer: Container;
    private bannerDetectiveMsgContainer: Container;
    private detectiveMsgText: Label;
    private displayMsg: string;
    private fullScreenBgAlpha: Bitmap;
    private closeButtonContainer: Container;
    // private closeButton: ButtonBase;
    private detectiveChar: Bitmap;
    private bannerMsgContainer: Container;
    private detectiveApeared: boolean = false;

    constructor(view: BannerScreenView) {
        this.view = view;
        this.initializeElements();
        this.subscribeEvents();
    }

    private initializeElements(): void {
        this.fullScreenBgAlpha = this.view.getImageById("fullScreenBgAlpha");
        this.bannerMainContainer = this.view.getContainerByID("bannerMainContainer");
        this.bannerBottomContainer = this.view.getContainerByID("bannerBottomContainer");
        this.bannerDetectiveContainer = this.view.getContainerByID("bannerDetectiveContainer");
        this.detectiveChar = this.view.getImageById("detectiveBg");
        this.bannerMsgContainer = this.view.getContainerByID("bannerMsgContainer");
        this.bannerDetectiveMsgContainer = this.view.getContainerByID("bannerDetectiveMsgContainer");
        this.closeButtonContainer = this.view.getContainerByID("closeButtonContainer");
        this.detectiveMsgText = this.view.getLabelById("detectiveMsgText") as Label;
    }

    private subscribeEvents(): void {
        dispatcher.on(eventDispatchers.CLUE_REWARD_MSG_BANNER, this.clueRewardBanner, this);
    }

    private clueRewardBanner(): void {
        this.closeButtonContainer.visible = false;
        (this.view.getButtonById("skipButton") as ButtonBase).visible = false
        this.view.getContainerByID("boardButtonContainer").visible = false
        this.removestageClick();
        const totalRevealedCount: number = (ingenuity.parserModel as GameParserModel).getTotalClueCount();
        if (this.msgCounter <= this.totalMsgOnEachCount[totalRevealedCount]) {
            this.view.visible = true;
            (ingenuity.soundManager as any).playSound(SoundConstantGame.CHAR_APPEAR, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
            this.resetMain();
            this.view.addToTop();
            this.bannerMainContainer.visible = true;
            this.fullScreenBgAlpha.visible = true;
            let localKey = "lbl_banner_2_" + totalRevealedCount + '_' + this.msgCounter;
            this.displayMsg = ingenuity.currentGame.cache.getJSON("lang")[localKey].text;
            this.playDetectiveScreen();
            this.msgCounter++;
        } else {
            this.msgCounter = 1;
            this.view.visible = false;
            this.removestageClick();
            this.clickCloseButton();
            dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
        }
    }

    private resetMain(): void {
        this.detectiveChar.x = this.detectiveChar.json.x;
        this.detectiveChar.y = this.detectiveChar.json.y;
        this.bannerMsgContainer.x = this.bannerMsgContainer.json.x;
        this.bannerMsgContainer.y = this.bannerMsgContainer.json.y;
        this.view.getContainerByID("criminalSection").visible = false;
        this.view.getContainerByID("locationSection").visible = false;
        this.view.getContainerByID("weaponSection").visible = false;
        this.view.getContainerByID("frameContainer").visible = false;
    }

    private clickCloseButton(): void {
        this.view.getImageById("closeButtonGlow").visible = false;
        this.view.getContainerByID("closeTapTextCont").visible = false;
        this.bannerMainContainer.visible = false;
        // this.closeButton.off(ButtonBase.DOWN, this.hideBannerView, this);
        // dispatcher.fireEvent(SlotEventConstants.ENABLED_ALL_BUTTONS);
        this.hideBannerView();
        this.resetContainers();
    }

    private hideBannerView(): void {
        this.view.visible = false;
    }
    private playDetectiveScreen(): void {
        !this.detectiveApeared &&
            dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, {
                id: SoundConstantGame.CHAR_APPEAR,
                vol: 0.8,
                loop: false,
                key: SlotConstantsBehavior.SOUND_LIST_PRELOAD,
            });
        this.detectiveApeared = true;

        if (this.bannerDetectiveContainer.visible) {
            this.changeDetectiveMsgDialoge();
            return;
        }
        this.playDetectiveScreenTween();
    }

    private playDetectiveScreenTween(): void {
        this.bannerDetectiveContainer.alpha = 0;
        let banneerTween: ITween;
        banneerTween = ingenuity.currentGame.add
            .tween(this.bannerDetectiveContainer)
            .to({ alpha: 1 }, 250, Linear.None, true, 0);
        banneerTween.onComplete.addOnce(() => {
            banneerTween.stop();
            this.bannerDetectiveContainer.visible = true;
            this.changeDetectiveMsgDialoge();
            ingenuity.currentGame.tweens.remove(banneerTween);
        });
    }

    private changeDetectiveMsgDialoge(): void {
        dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, {
            id: SoundConstantGame.DIALOGUE_CLOUD_SOUND,
            vol: 0.8,
            loop: false,
            key: SlotConstantsBehavior.SOUND_LIST_PRELOAD,
        });

        if (this.bannerDetectiveMsgContainer.visible) {
            this.bannerDetectiveMsgContainer.scale.set(1);
            let banneerTweenMsgOut: ITween;
            banneerTweenMsgOut = ingenuity.currentGame.add
                .tween(this.bannerDetectiveMsgContainer.scale)
                .to({ x: 0, y: 0 }, 250, Linear.None, true, 0);
            banneerTweenMsgOut.onComplete.addOnce(() => {
                banneerTweenMsgOut.stop();
                this.detectiveMsgText.setText(this.displayMsg);
                ingenuity.currentGame.tweens.remove(banneerTweenMsgOut);
                this.addstageClick()
                let banneerTweenMsgIn: ITween;
                banneerTweenMsgIn = ingenuity.currentGame.add
                    .tween(this.bannerDetectiveMsgContainer.scale)
                    .to({ x: 1, y: 1 }, 250, Linear.None, true, 0);
                banneerTweenMsgIn.onComplete.addOnce(() => {
                    banneerTweenMsgIn.stop();
                    ingenuity.currentGame.tweens.remove(banneerTweenMsgIn);
                });
            });
        } else {
            this.bannerDetectiveMsgContainer.visible = true;
            this.bannerDetectiveMsgContainer.scale.set(0);
            this.detectiveMsgText.setText(this.displayMsg);
            let banneerTweenMsgIn: ITween;
            banneerTweenMsgIn = ingenuity.currentGame.add
                .tween(this.bannerDetectiveMsgContainer.scale)
                .to({ x: 1, y: 1 }, 250, Linear.None, true, 0);
            banneerTweenMsgIn.onComplete.addOnce(() => {
                banneerTweenMsgIn.stop();
                this.addstageClick()
                ingenuity.currentGame.tweens.remove(banneerTweenMsgIn);
            });
        }
        this.bannerBottomContainer.visible = true;
    }

    private addstageClick(): void {
        ingenuity.currentGame.input.onDown.add(this.clueRewardBanner, this);
    }

    private removestageClick(): void {
        ingenuity.currentGame.input.onDown.remove(this.clueRewardBanner, this);
    }

    private resetContainers(): void {
        this.detectiveApeared = false
        this.bannerDetectiveMsgContainer.visible = false;
        this.bannerDetectiveContainer.visible = false;
        this.bannerDetectiveMsgContainer.alpha = 1;
    }
}
